import styled, { css } from 'styled-components/macro';
import { colorBlack } from '../../../../../utils/css/colors';
import ButtonSmall from '../../../../common/ButtonSmall';
import { body14 } from '../../../../../utils/css/typography';
import { boldFont } from '../../../../../utils/css/fonts';
import { Card } from '../../../CommonStyles';
import { mobile } from '../../../../../utils/css/media';

export const LabelLink = styled.span`
  text-decoration: underline;
  color: ${colorBlack};
  margin: 0 5px;
`;

export const FieldsContainer = styled.div`
  width: 100%;
`;

export const CheckboxesContainer = styled.div`
  margin: 3.4rem -1rem 5.3rem 0;
`;

export const RegisterHostButton = styled(ButtonSmall)`
  ${body14};
  font-family: ${boldFont};
  width: 39.6%;
  padding: 1.4rem;
  width: 100%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ErrorsContainer = styled.div`
  margin-inline-start: 3.4rem;
`;

export const BottomTextContainer = styled.div`
  margin-top: 2.5rem;
  margin-right: 3rem;
  font-size: 1.6rem;
  ${mobile(css`
    margin-right: 0;
    align-self: center;
  `)}
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 3rem;
  margin-bottom: 1rem;

  ${mobile(css`
    bottom: 0;
  `)}
`;

// @ts-ignore
export const RegisterCard = styled(Card)`
  width: 692px;
`;
